import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    showTicketFormUi,
    showTicketListUi,
    deleteAllTicketById,
    getTicketById
} from '../../../../../../../app/store/slices/ticket/ticket';

export default function useDeleteTicket() {
    const dispatch = useDispatch();
    const { showTicketForm, showTicketList, tickets } = useSelector((state) => state.ticket);
    const [selectedTicketId, setSelectedTicketId] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [cannotDelete, setCannotDelete] = useState(false);

    const purchasedTicket = [
        {
            id: 169,
            ticketSold: '23'
        },
        {
            id: 170,
            ticketSold: '15'
        },
        {
            id: 171,
            ticketSold: '10'
        },
        {
            id: 172,
            ticketSold: '0'
        }
    ];

    async function deleteTicket() {
        try {
            await dispatch(deleteAllTicketById([selectedTicketId])).unwrap();
            setOpenDeleteDialog(false);
        } catch (error) {
            console.error('Error deleting ticket:', error);
        }
    }

    async function fetchTicketById(ticketId) {
        try {
            await dispatch(getTicketById(ticketId)).unwrap();
            dispatch(showTicketFormUi({ showTicketForm: true }));
            dispatch(showTicketListUi({ showTicketList: false }));
        } catch (error) {
            console.error('Error fetching ticket:', error);
        }
    }

    // function fetchTicketById(ticketId) {
    //     const ticket = tickets.find((ticket) => ticket.ticket_id === ticketId);
    //     if (ticket) {
    //         // Update the UI state
    //         dispatch(setSelectedTicket(ticket));
    //         dispatch(showTicketFormUi({ showTicketForm: true }));
    //         dispatch(showTicketListUi({ showTicketList: false }));
    //     } else {
    //         console.error("Ticket not found in state.");
    //     }
    // }

    // function handleOpenDeleteDialog(ticketId) {
    //     setSelectedTicketId(ticketId);
    //     setOpenDeleteDialog(true);
    // }

    function handleOpenDeleteDialog(ticketId) {
        const ticket = purchasedTicket.find((pTicket) => pTicket.id === ticketId);
        if (ticket && parseInt(ticket.ticketSold) > 0) {
            setCannotDelete(true); // Prevent deletion if ticketSold > 0
        } else {
            setCannotDelete(false); // Allow deletion
        }
        setSelectedTicketId(ticketId);
        setOpenDeleteDialog(true);
    }

    function handleCloseDeleteDialog() {
        setOpenDeleteDialog(false);
        setSelectedTicketId(null);
    }

    return {
        openDeleteDialog,
        deleteTicket,
        handleOpenDeleteDialog,
        handleCloseDeleteDialog,
        fetchTicketById,
        cannotDelete
    };
}
